import { Provider } from 'react-redux';
import { createStore } from 'redux';

import { store } from '../index';
import { updateFileUploadProgress } from './files/actionCreators';
import rootReducer from './rootReducer';

export function wrapComponent(component, initialState = null) {
  return <Provider store={createStore(rootReducer, initialState || {})}>{component}</Provider>;
}

export function addDefaultFileValues(files, infoFields) {
  return files.map((file, index) => ({
    index: index,
    infoFields: infoFields,
    originalFileData: file, // Store the original uploader File.prototype object as-is for eventual upload
    values: [], // Form is initialized empty
    readyToUpload: false,
    status: 'Needs Input',
    uploadProgress: 0,
    error: {},
  }));
}

// Manage upload progress
export function progressCallback(index, uploadProgress) {
  store.dispatch(updateFileUploadProgress(index, Math.round((uploadProgress.loaded / uploadProgress.total) * 100)));
}
